<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="pl-3">
            <span class="newFolderTitle"
              >{{ edit ? $t('message.rename') : $t('message.create') }}
              {{ $t('message.new') }} {{ $t('message.folder') }}</span
            >
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-container class="pl-0">
            <v-row no-gutters>
              <v-col cols="12" class="mb-2">
                <span class="newFolderName">{{ $t('message.name') }}</span>
              </v-col>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" v-on:submit.prevent>
                  <v-text-field
                    v-model="folder.name"
                    autofocus
                    outlined
                    dense
                    :rules="[rules.required, rules.maxLength, rules.minLength]"
                    required
                    counter="255"
                    color="primary"
                    @keyup.enter="handleEnter"
                  ></v-text-field>
                </v-form>
              </v-col>
              <v-col cols="12" class="mt-3 mb-2">
                <v-divider />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-4 px-4 rounded-lg elevation-0"
            :disabled="isFetching"
            color="#EDEEF1"
            @click="handleClose"
          >
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="px-10 rounded-lg elevation-0"
            @click="handleCreate"
            :loading="isFetching"
            v-if="!edit"
            :disabled="!valid || isFetching"
          >
            {{ $t('message.create') }} {{ $t('message.folder') }}
          </v-btn>
          <v-btn
            large
            class="primary white--text rounded-lg elevation-0"
            min-width="120px"
            @click="handleEdit"
            v-else
            :loading="isFetching"
            :disabled="!valid || isFetching"
          >
            {{ $t('message.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import i18n from '@/translations/lang'
import foldersApi from '../services/foldersApi'

export default {
  name: 'FolderModal',
  components: {},
  data: () => ({
    open: null,
    isFetching: false,
    folder: {
      name: '',
    },
    edit: false,
    folderId: '',
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 255) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
  }),
  watch: {
    open(val) {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
      if (val === false) this.$root.$emit('FolderModalRenameHasClosed')
    },
  },
  mounted() {
    this.$root.$on('folderModal', (folder) => {
      this.$root.$emit('renameModalOpened')
      this.folder = folder
      this.edit = folder.edit
      this.folderId = folder.id
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('folderModal')
    this.$root.$emit('resetIsAnyOtherModal')
    this.$root.$emit('renameModalClosed')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    async handleCreate() {
      this.isFetching = true
      let folderObject = {
        name: this.folder.name.trim(),
      }
      if (this.$route.params.id) {
        folderObject['parent_folder_id'] = this.$route.params.id
      }
      try {
        let ret = await foldersApi.createFolder(folderObject)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `Pasta ${ret.data.name} criada`,
        })
        this.addFolder(ret.data)
        this.$root.$emit('addFolderVideosPage', ret.data)
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `${e}`,
        })
      }
      this.isFetching = false
      this.handleClose()
    },
    async handleEdit() {
      this.isFetching = true
      try {
        let ret = await foldersApi.updateFolder(
          { name: this.folder.name.trim() },
          this.folderId
        )
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `Pasta ${ret.data.name} renomeada`,
        })
        this.editFolder(ret.data)
        this.$root.$emit('updateFolderVideosPage', ret.data)
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `${e}`,
        })
      }
      this.isFetching = false
      this.handleClose()
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
    },
    handleEnter() {
      if (this.valid) {
        this.edit ? this.handleEdit() : this.handleCreate()
      }
    },
  },
}
</script>

<style>
.newFolderTitle {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
}
.newFolderName {
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #282931;
}
</style>
